// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-chip--select[data-v-d4a2a218]{background-color:#e8f6f5!important;color:#08806d!important;font-weight:700!important}.v-menu__content[data-v-d4a2a218]{max-height:80vh!important}.v-menu__content .v-list-item__title[data-v-d4a2a218]{line-height:30px!important;white-space:normal}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
